import React from 'react'

import { Icon, ChevronLeft, ChevronRight, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, string, bool, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import BrowseAllRow from '../BrowseAllRow/BrowseAllRow'

const CHEVRON_SIZE = { width: '16', height: '16' }
const ITEM_CHEVRON_SIZE = { width: '12', height: '12' }

// Secondary submenu revealed when a category is hovered (desktop) or its chevron is
// tapped (mobile). One markup, two presentations driven by CSS: a compact floating
// popover to the right of the row at md+, and a full-width push panel with a back
// header below md (matching the Figma mobile drill-in). Open/close is JS-driven by
// the parent's useSubcategoryMenu so it mirrors the legacy behaviour.
//
// On mobile the flyout overlays the whole panel, so the persistent "Browse all" row is
// re-rendered pinned at its top (mobile-only via the `__browse` class) to match Figma.
function SubcategoryFlyout({
  id = undefined,
  subcategories,
  categoryTitle = '',
  isOpen,
  onClose = NOOP,
  onLinkClick = NOOP,
  browseAllHref = undefined,
  browseAllLabel = undefined,
}) {
  const items = subcategories.filter(Boolean)

  return (
    <div
      id={id}
      className={classnames(
        'category-mega-menu__flyout',
        isOpen && 'category-mega-menu__flyout--open'
      )}
    >
      {browseAllHref && browseAllLabel && (
        <BrowseAllRow href={browseAllHref} label={browseAllLabel} />
      )}
      <button
        type="button"
        className="category-mega-menu__flyout-back"
        onClick={onClose}
      >
        <Icon notSpaced color="dark" size={CHEVRON_SIZE} svgComponent={ChevronLeft} />
        <span className="category-mega-menu__flyout-back-label cgt-overline-md">{categoryTitle}</span>
      </button>
      <ul className="category-mega-menu__flyout-list">
        {items.map((subcategory) => (
          <li key={subcategory.title || subcategory.name} className="category-mega-menu__flyout-item">
            <a
              href={subcategory.path}
              className="category-mega-menu__flyout-link cgt-body-base-semibold"
              onClick={(event) => onLinkClick(event, subcategory.path)}
            >
              <span className="category-mega-menu__flyout-link-label">
                {subcategory.title || subcategory.name}
              </span>
              <Icon
                notSpaced
                color="dark"
                size={ITEM_CHEVRON_SIZE}
                svgComponent={ChevronRight}
                className="category-mega-menu__flyout-link-chevron"
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

SubcategoryFlyout.propTypes = {
  id: string,
  subcategories: array.isRequired,
  categoryTitle: string,
  isOpen: bool.isRequired,
  onClose: func,
  onLinkClick: func,
  browseAllHref: string,
  browseAllLabel: string,
}

export default SubcategoryFlyout
